import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SinusitisPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Sinusitis</h1>
        <section className="mb-8">
          <p>Sinusitis is an inflammation of the sinuses that can cause significant discomfort. Our natural therapies focus on reducing inflammation, clearing congestion, and strengthening the immune system through gentle, effective herbal remedies and lifestyle modifications.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Viral infections</li>
            <li>Bacterial infections</li>
            <li>Allergies</li>
            <li>Nasal polyps</li>
            <li>Deviated septum</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Facial pain and pressure</li>
            <li>Nasal congestion</li>
            <li>Thick nasal discharge</li>
            <li>Reduced sense of smell</li>
            <li>Headache</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use anti-inflammatory herbs, decongestants, and immune-boosting remedies to naturally treat sinusitis. Our approach focuses on reducing inflammation, clearing nasal passages, and strengthening the body's natural defenses through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural decongestion</li>
            <li>Reduced inflammation</li>
            <li>Strengthened immunity</li>
            <li>Long-term relief</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Steam inhalation</li>
            <li>Nasal irrigation</li>
            <li>Stay hydrated</li>
            <li>Avoid allergens</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within 1-2 weeks of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for chronic sinusitis?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for long-term management of chronic sinusitis.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by strengthening the immune system and addressing underlying causes.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from sinusitis—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default SinusitisPage; 